<template>
  <section>
    <div>
      <tabs class="pl-6 sm:pl-1" v-model="selectedTab">
        <tab class="
            text-white
            pl-0
            rounded-md
            border border-white
            mr-8
            mb-6
            sm:mr-4 sm:mb-4
            cursor-pointer
          " :class="activeClass(i)" v-for="(menu, i) in foodMenu" :key="i" :val="menu.category" :label="menu.category"
          :indicator="true" @click="switchTab(i)" />
      </tabs>
      <tab-panels v-model="selectedTab" :animate="false">
        <tab-panel class="bc-tab-panel text-white blue px-6 pt-8 sm:px-1 table-cell"
          v-for="(item, index) in foodMenu[key].items" :key="index" :val="item">
          <div class="w-full border-b flex h-full pb-8">
            <p class="
                inline-block
                float-left
                w-2/3
                uppercase
                text-base
                sm:text-sm
              ">
              {{ item.name }}
            </p>
            <p class="inline-block float-right w-1/3 text-right sm:text-sm">
              {{ item.price }}
            </p>
          </div>
        </tab-panel>
      </tab-panels>
    </div>
    <div class="text-white px-6 sm:px-0 mt-8">
      <h1 class="text-xl font-serif">*We have a liquor licence</h1>
      <p class="text-sm">
        Please inform us if you have any food allergies before ordering, We will
        try our best to accommodate. There will not be additional notice for all
        changes in Ingredients or Price
      </p>
    </div>
  </section>
</template>

<script>
//import axios from "axios";
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";
//import HelperTools from "../utilities/helper";
export default {
  data() {
    return {
      key: 0,
      isActive: false,
      foodMenu: [
        {
          category: "APPETIZER",
          items: [
            {
              name: "Red Bean Pan Cake(Sweet)",
              price: "1pcs:$6.50, 2pcs:$10.99 3pcs:$14.99"
            },
            {
              name: "Juicy Beef Pancake(Mild Spicy)",
              price: "1pcs:$7.99, 2pcs:$12.99 3pcs:$17.99"
            },
             {
              name: "Deep Fried Shrimp Wonton(8pcs)",
              price: "$12.99"
            },
            {
              name: "bbq whole squid",
              price: "$21.99"
            },
            {
              name: "bbq short rib ",
              price: "$29.99"
            },
            {
              name: "yummy stir fried mussel",
              price: "$21.99"
            },
            {
              name: "Saba Shioyaki(BBQ Mackerel)",
              price: "$17.99"
            },
            {
              name: "Takoyaki  ",
              price: "$7.95"
            },
            {
              name: "Ebi Gyoza   ",
              price: "$8.95"
            },
            {
              name: "Gyoza   ",
              price: "$7.95"
            },
            {
              name: "Shrimp Gyoza   ",
              price: "$8.95"
            },
            {
              name: "Pork Gyoza   ",
              price: "$7.55"
            },
            {
              name: "Miso   ",
              price: "$2.50"
            },
            {
              name: "Kimchi   ",
              price: "$4.25"
            },
            {
              name: "Rice   ",
              price: "$2.50"
            },
            {
              name: "ika karaage   ",
              price: "$13.99"
            },
            {
              name: "Chicken Karaage   ",
              price: "$13.99"
            },
            {
              name: "Agedashi Tofu   ",
              price: "$7.75"
            },
            {
              name: "Deep Fried Spicy Yummy Egg Tofu   ",
              price: "$7.99"
            },
            {
              name: "Pumpkin Croquette   ",
              price: "$7.75"
            },
            {
              name: "Deep Fried Chicken Wing  ",
              price: "$10.99"
            },
            {
              name: "Spring Roll",
              price: "$6.95"
            },
            {
              name: "Edamame",
              price: "$7.50"
            },
            {
              name: "Goma-Ae",
              price: "$6.55"
            },
            {
              name: "Seaweed Salad",
              price: "$6.25"
            },
            {
              name: "Yam Tempura (8pc)",
              price: "$12.99"
            },
            {
              name: "Appetizer Tempura (4pcs Vege, 2pcs Prawn)",
              price: "$10.25"
            },
            {
              name: "Prawn Tempura (6pc)",
              price: "$12.99"
            },
            {
              name: "Assorted Tempura (2 pcs Prawn, 6 pcs Vege)",
              price: "$15.55"
            },
            {
              name: "Deluxe Eel Tempura (1pc Big size eel, 4pcs yam tempura, 2pcs Asparagus 2pcs Salmon Tempura 2pcs Prawn)",
              price: "$28.99"
            },
            {
              name: "Vegetable Tempura (8pc)",
              price: "$11.99"
            },
            {
              name: "Prawn & Yam Tempura (4pc Prawn, 4pc Yam)",
              price: "$12.99"
            },
            {
              name: "Avoacdo Tempura (4pc)",
              price: "$7.99"
            },
            {
              name: "Salmon Friend (4pcs mild spicy)",
              price: "$11.99"
            },
            {
              name: "Soft Shell Crab Tempura",
              price: "$12.99"
            },
            {
              name: "Vegetable Sunomono",
              price: "$5.25"
            },
            {
              name: "Ebi Sunomono",
              price: "$6.55"
            },
            {
              name: "Tako Sunomono",
              price: "$5.25"
            },
            {
              name: "House Green Salad",
              price: "$14.55"
            },
            {
              name: "seafood salad",
              price: "$18.99"
            },
            {
              name: "tuna & salmon salad",
              price: "$16.99"
            }
          ]
        },
        {
          category: "SASHIMI",
          items: [
            {
              name: "Appetizer Sashimi (3pc Salmon, 2pc Tuna)",
              price: "$14.99"
            },
            {
              name: "assorted sashimi (15pc)",
              price: "$30.99"
            },
            {
              name: "tuna&salmon sashimi (8pc)",
              price: "$22.55"
            },
            {
              name: "spicy toro sashimi (8pc)",
              price: "$25.99"
            },
            {
              name: "spicy tuna sashimi",
              price: "$14.99 half $21.55 full"
            },
            {
              name: "spicy salmon sashimi",
              price: "$15.55 half $22.55 full"
            },
            {
              name: "tuna tataki",
              price: "$21.55"
            },
            {
              name: "saba sashimi",
              price: "$9.55 3pcs $17.55 6pc $23.99 9pcs"
            },
            {
              name: "tuna sashimi",
              price: "$9.99 3pcs $17.55 5pc $23.99 9pcs"
            },
            {
              name: "salmon sashimi",
              price: "$9.99 3pcs $17.55 5pc $23.99 9pcs"
            },
            {
              name: "toro sashimi",
              price: "$10.99 3pcs $19.55 6pc $27.99 9pcs"
            },
            {
              name: "wild salmon sashimi",
              price: "$10.99 3pcs $19.55 6pc $28.55 9pcs"
            },
            {
              name: "tako sashimi",
              price: "$12.20 4pcs $22.20 8pcs"
            },
            {
              name: "Hotate sashimi",
              price: "$11.99 3pcs $22.99 6pcs"
            }
          ]
        },
        {
          category: "SUSHI",
          items: [
            {
              name: "ebi",
              price: "$2.95"
            },
            {
              name: "tai",
              price: "$2.95"
            },
            {
              name: "Saba",
              price: "$2.95"
            },
            {
              name: "inari",
              price: "$2.95"
            },
            {
              name: "tobiko",
              price: "$2.95"
            },
            {
              name: "Tamago",
              price: "$2.95"
            },
            {
              name: "masago",
              price: "$2.95"
            },
            {
              name: "hokkigai",
              price: "$2.95"
            },
            {
              name: "Scallop",
              price: "$3.25"
            },
            {
              name: "tuna",
              price: "$3.25"
            },
            {
              name: "toro",
              price: "$3.25"
            },
            {
              name: "Unagi",
              price: "$3.25"
            },
            {
              name: "salmon",
              price: "$3.25"
            },
            {
              name: "Salmon Oshi",
              price: "$17.00"
            },
            {
              name: "Tuna Oshi",
              price: "$17.00"
            },
            {
              name: "saba Oshi",
              price: "$17.00"
            },
             {
              name: "Avocado Oshi",
              price: "$16.55"
            },
            {
              name: "aburi Salmon",
              price: "$4.25"
            },
            {
              name: "aburi tuna",
              price: "$4.25"
            },
            {
              name: "aburi saba",
              price: "$4.25"
            },
            {
              name: "aburi toro",
              price: "$4.25"
            },
            {
              name: "aburi hotate",
              price: "$5.75"
            }]
        },
        {
          category: "Maki&Roll",
          items: [
            {
              name: "dynamite roll",
              price: "$6.75"
            },
            {
              name: "Spicy salmon & avocado roll",
              price: "$7.99"
            },
            {
              name: "spicy salmon roll",
              price: "$7.99"
            },
            {
              name: "spicy tuna roll",
              price: "$7.99"
            },
            {
              name: "salmon tempura roll",
              price: "$7.75"
            },
            {
              name: "chicken teriyaki roll",
              price: "$8.25"
            },
            {
              name: "tuna & avocado roll",
              price: "$7.99"
            },
            {
              name: "salmon & avocado roll",
              price: "$7.99"
            },
            {
              name: "smoke salmon & avocado roll",
              price: "$7.55"
            },
            {
              name: "spicy tuna avocado roll",
              price: "$7.99"
            },
            {
              name: "spicy scallop roll",
              price: "$7.99"
            },
            {
              name: "beef teriyaki roll",
              price: "$8.25"
            },
            {
              name: "b.c roll (BBQ Salmon Skin)",
              price: "$6.75"
            },
            {
              name: "inari roll",
              price: "$5.25"
            },
            {
              name: "yam & avocado roll",
              price: "$6.55"
            },
            {
              name: "scallop roll",
              price: "$6.99"
            },
            {
              name: "crab meat & smoked salmon roll ",
              price: "$7.75"
            },
            {
              name: "tamago roll",
              price: "$5.75"
            },
            {
              name: "california roll",
              price: "$5.99"
            },
            {
              name: "avocado roll",
              price: "$5.75"
            },
            {
              name: "vegg tempura roll",
              price: "$5.95"
            },
            {
              name: "yam roll",
              price: "$6.55"
            },
            {
              name: "vegetables roll",
              price: "$5.99"
            },
            {
              name: "unagi avocado roll",
              price: "$7.99"
            },
            {
              name: "mango&avocado roll",
              price: "$6.75"
            },
            {
              name: "Avocado&Cucumber roll",
              price: "$6.55"
            },
            {
              name: "mango& crab meat roll",
              price: "$7.50"
            },
            {
              name: "mango&tuna roll",
              price: "$8.25"
            },
            {
              name: "mango&salmon roll",
              price: "$8.25"
            },

            {
              name: "negitoro maki",
              price: "$4.75"
            },
            {
              name: "salmon maki",
              price: "$3.95"
            },
            {
              name: "wild salmon maki",
              price: "$4.99"
            },
            {
              name: "kappa maki",
              price: "$3.75"
            },
            {
              name: "oshinko maki",
              price: "$3.75"
            },
            {
              name: "Tuna maki",
              price: "$3.95"
            },
            {
              name: "Unagi Avocado Roll",
              price: "$7.99"
            },
            {
              name: "Smoked Salmon Avo Cheese Roll",
              price: "$9.25"
            },
            {
              name: "Avocado and cheese Roll",
              price: "$6.99"
            },
            {
              name: "Asparagus Avocado Roll",
              price: "$5.99"
            },
            {
              name: "Asparagus Maki",
              price: "$4.25"
            },
            {
              name: "Asparagus Cuccumber Roll",
              price: "$5.55"
            },
          ]
        },
        {
          category: "Chef's Roll",
          items: [
            {
              name:
                "King Crab Roll: Real Crab Meat, Avocado, Yam\nTobiko, Mayonnaise, Eel Sauce",
              price: "$18.99"
            },
            {
              name:
                "Canuck Roll: Cucumber, Crab Meat\nMayonnaise, Eel Sauce\nSmoked Salmon, Prawn Tempura",
              price: "$13.99"
            },
            {
              name:
                "Dragon Roll : Tobiko with Mayonnaise\n2pcs Eel Tempura, Eel Sauce\n2pcs Prawn Tempura, Avocado",
              price: "$18.99"
            },
            {
              name:
                "Spider Man Roll (Torch): Whole Deep Fried Soft Shell Crab\nSealed Tuna, Eel Sauce， Mayonnaise",
              price: "$18.99"
            },
            {
              name: "Baby Butterfly Roll: Eel and Crab meat, Roll Up Avocado, Tobiko, Mayonnaise, Eel Sauce",
              price: "$17.99"
            },
            {
              name: "Crispy Tuna Delight Roll (Spicy) : Chef Made Special Spicy Sauce\nYam, Spicy Tuna, Tempura Fritter\nGreen Onion, Eel Sauce, Mayonnaise",
              price: "$16.99"
            },
            {
              name:
                "Ocean Garden Roll (6pc) : Salmon, Avocad, Crab,Obiko\nEel Wrapped in Thiny Sliced Cucumber \nwith Ponzu Sauce",
              price: "$16.99"
            },
            {
              name:
                "Jade \nRoll : Avocado, Yam, \nSpinach, Deep Fried Shredded yam, Sesame\nPaste Sauce on Top",
              price: "$12.99"
            },
            {
              name:
                "Crunch\nRoll : 2 Prawns and Avocado\nRolled Up, Tempura Fritter\nEel Sauce on top",
              price: "$12.55"
            },
            {
              name:
                "Lover\nRoll (Spicy & Torch) : Prawn Tempura, Avocado\nSpicy Mayo Sauce on top\nSalmon Tempura on top with Jalapeño",
              price: "$17.99"
            },
            {
              name:
                "California crunch\nRoll (Mild Spicy & Torch) : Crabmeat, Avocado\nSesame Paste Sauce\nDeep Fried Shredded Yam on top",
              price: "$11.99"
            },
            {
              name:
                "Deluxe Sakura\nRoll (Mild Spicy & Torch): Prawn tempura, Cucumber\nMayonnaise, Crab Meat\nMasago, Eel Sauce, Shredded mix cheese, tobiko, House spicy sauce",
              price: "$17.55"
            },
            {
              name:
                "Yummy Roll (Spicy & Toch) : prawn tempura\navocado, cheese, yam\nyummy sauce, eel sauce, tobiko",
              price: "$16.99"
            },
            {
              name:
                "Kamikaze\nRoll (Spicy): Spicy Tuna, Avocado，cheese\nand Fish Roe Rolled Up\nTempura Style Deep Fried\nServed with Ponzu Sauce",
              price: "$15.99"
            },
            {
              name:
                "hawaii roll: salmon   avocado   eel   tobiko\nmango on top   mango sauce",
              price: "$17.99"
            },
            {
              name:
                "hotate roll (Torch): crab meat, big sized hotate,tobiko\nPRAWN TEMPURA, AVOCADO\nchef made butter sauce",
              price: "$22.99"
            },
            {
              name:
                "lobster roll (Torch): lobster, tobiko\navocado, prawn tempura\nchef made butter sauce, Tobiko and imitation crab meat salad in the shell",
              price: "$28.99"
            },
            {
              name: "ALASKA ROLL: crab meat, cuccumber, avocado, salmon, tobiko",
              price: "$13.99"
            },
            {
              name: "AMAZING ROLL: crab meat, yam, cuccumber, avocado, eel sauce, Prawn, smoked salmon on top",
              price: "$14.99"
            },
            {
              name: "RAINBOW ROLL: crab meat, avocado, salmon, tuna, ebi, tai, tobiko, mayonnaise",
              price: "$16.99"
            },
            {
              name: "GOLDEN CALIFORNIA ROll: crab meat, avocado, cheese, deep fried, tobiko, eel sause and mayonnaise",
              price: "$14.99"
            },
            {
              name: "PHILADELPHIA ROLL: salmon, avocado, cream cheese, smoked salmon on top, eel sauce and tobiko",
              price: "$15.99"
            },
            {
              name: "house roll: Salmon, Tuna, Avocado, Crab Meat, Cuccumber, Tamago, Tobiko",
              price: "$15.99"
            },
            {
              name: "Volcano Roll (Spicy & torch): Prawn tempura, avocado with Pineapple, crab meat, cheese, volcano (mayonnaise) sauce on top, Torched",
              price: "$20.99"
            },
            {
              name: "Golden Chicken (deep fried): Cheddar cheese, chicken, avocado roll up with bread crumbs, chef special spicy sauce(Dynamite size)",
              price: "$14.99"
            },
            {
              name: "Phoenix Roll (spicy): chicken, cuccumber, cream cheese roll up with tempura fritter and house made phoenix sause and eel sauce (dynamite sauce)",
              price: "$12.99"
            },
            {
              name: "Jungle Roll (vegan): Asparagus, Oshinko, avocado tempura, seaweed salad and sesame sauce",
              price: "$13.99"
            },
            {
              name: "Double Cheese Roll(Torch Spicy): Yam tempura, Prawn tempura, Cream Cheese, Raw Spicy Salmon, Cheddar Cheese, Special Spicy Sauce Eel Sauce, Yam shredded, Tobiko",
              price: "$15.99"
            },
            {
              name: "Triple Cheese Tempura Roll(NO RICE, Torch, Spicy): Crabmeat, cucumber, prawn tempura, cream cheese, cheddar cheese, spicy tuna, shredded cheese, eel sauce, chef spicy sauce",
              price: "$17.99"
            },
          ]
        },
        {
          category: "A LA-CARTE",
          items: [
            {
              name: "Tofu Teriyaki + RICE & SOUP",
              price: "$16.55"
            },
            {
              name: "Beef Teriyaki + RICE & SOUP",
              price: "$19.55"
            },
            {
              name: "Chicken Teriyaki + RICE & SOUP",
              price: "$19.55"
            },
            {
              name: "Salmon Teriyaki + RICE & SOUP",
              price: "$25.99"
            },
            {
              name: "Seafood Teriyaki + RICE & SOUP",
              price: "$24.99"
            }
          ]
        },
        {
          category: "DONBURI RICE BOWL",
          items: [
            {
              name: "Unagi Don 7pcs",
              price: "$22.55"
            },
            {
              name: "Chirashi Don 12pcs",
              price: "$30.99"
            },
            {
              name: "Tuna Don 8pcs",
              price: "$23.99"
            },
            {
              name: "Salmon Don 8pcs",
              price: "$23.99"
            },
            {
              name: "Tuna&Salmon Don 8pcs",
              price: "$23.99"
            },
            {
              name: "Wild Salmon Don 8pcs",
              price: "$25.99"
            },
            {
              name: "Spicy Salmon Sashimi Don",
              price: "$25.99"
            },
            {
              name: "Spicy Tuna Sashimi Don",
              price: "$25.99"
            },
            {
              name: "Chicken Teriyaki Don",
              price: "$16.99"
            },
            {
              name: "Beef Teriyaki Don",
              price: "$16.99"
            },
            {
              name: "chicken fried rice",
              price: "$21.99"
            },
            {
              name: "tofu teriyaki don",
              price: "$14.55"
            },
            {
              name: "salmon teriyaki don",
              price: "$22.99"
            },
            {
              name: "tonkatsu (pork) with rice + salad",
              price: "$17.55"
            },
            {
              name: "Beef don with egg",
              price: "$17.55"
            },
            {
              name: "Katsu don with egg",
              price: "$17.55"
            },

          ]
        },
        {
          category: "COMBO",
          items: [
            {
              name: "Triple Combo: Tuna Maki, Kappa Maki, Salmon Makia   ",
              price: "$10.99"
            },
            {
              name: "Sakura Combo: Sakura Roll, Tuna Maki, Salmon Maki   ",
              price: "$19.89"
            },
            {
              name:
                "Tuna & Salmon Combo: Tuna Maki, Salmon Maki, 2pcs Tuna, 2pc Salmon  ",
              price: "$18.99"
            },
            {
              name: "ABURI SUSHI COMBO: 2PCS TUNA, 2PCS SABA, 2PCS SALMON  ",
              price: "$22.99"
            },
            {
              name:
                "California Combo: 2pc EBI, California Roll, 2pcs Tuna, 2pc Salmon   ",
              price: "$19.99"
            },
            {
              name:
                "Spicy Combo: Spicy Tuna Roll, Spicy Salmon Roll, Spicy Dynamite Roll  ",
              price: "$22.99"
            },
            {
              name: "Dynamite Combo: Dynamite Roll, Tuna Maki, Salmon Maki  ",
              price: "$14.99"
            },
            {
              name: "Crunch Combo: Cruch Roll, Crispy Tuna Delight Roll  ",
              price: "$24.99"
            },
            {
              name:
                "crispy tuna delight combo: crispy tuna delight roll, spicy salmon roll   ",
              price: "$22.99"
            },
            {
              name: "kamikaze combo: kamikaze roll, spicy dynamite roll   ",
              price: "$21.99"
            },
            {
              name: "king crab combo: king crab roll, avocado Roll   ",
              price: "$22.99"
            },
            {
              name: "vegetable combo: kappa maki, yam roll vegetable roll   ",
              price: "$14.99"
            },
            {
              name: "canuck combo: canuck roll, california roll   ",
              price: "$18.99"
            },
            {
              name:
                "for 2: Appetizer sashimi, 6pcs salmon Or tuna oshi\n1 chicken Or Beef teriyaki, 1 order Canuck Roll, 2 miso",
              price: "$58.99"
            },
            {
              name:
                "for 4: 8pcs salmon&tuna sashimi, 6pcs salmon Or tuna oshi, 4miso \nDragon Roll, king carb roll, chicken Or Beef teriyaki, Assortd tempura  ",
              price: "$100.99"
            },
            {
              name:
                "for 6: 15pcs Assorted Sashimi, 6pcs Aburi sushi combo, 6pcs salmon Or tuna oshi, Assorted tempura \n, Lover roll, King carb roll, chicken karaage \nchicken fried rice Or chicken yaki soba, 6 miso   ",
              price: "$159.99"
            }
          ]
        },
        {
          category: "NOODLE",
          items: [
            {
              name: "Beef or chicken Yaki Soba",
              price: "$19.55"
            },
            {
              name: "Spicy Beef Yaki Soba",
              price: "$20.55"
            },
            {
              name: "Pork Ramen",
              price: "$17.55"
            },
            {
              name: "Beef Or Chicken Udon Soup",
              price: "$15.99"
            },
            {
              name: "beef Or chicken yaki udon",
              price: "$19.55"
            },
            {
              name: "Seafood Udon",
              price: "$17.55"
            },
            {
              name: "Seafood Yaki Soba",
              price: "$20.55"
            },
            {
              name: "Seafood Yaki Udon",
              price: "$20.55"
            },
            {
              name: "vegg yaki udon",
              price: "$17.99"
            },
            {
              name: "tempura udon",
              price: "$17.99"
            },
            {
              name: "vegetable udon soup",
              price: "$14.99"
            },
            {
              name: "Vegetable yaki soba",
              price: "$17.55"
            },
            {
              name: "Wonton Soup",
              price: "$12.99 Add Noodle +$5"
            },
          ]
        },
        {
          category: "SUSHI PARTY TRAYS",
          items: [
            {
              name:
                "Sushi Party Tray A (2-3ppl) : 1 Salmon Maki, 1 Tuna Maki. 1 Kappa Maki, 2 Amazing Roll 2 California Roll, 2 Pcs Tuna Nigiri, 2 Pcs Salmon Nigiri",
              price: "$58.99"
            },
            {
              name:
                " Sashimi Party Tray B (2-3ppl) : 3 Pc Salmon Sashimi, 2Pc Tuna Sashimi, Dragon Roll, 1 Avocado Roll,1 Dynamite Roll,1 California Roll,1 Salmon Maki, 3 Pcs Tuna Nigiri, 3pcs salmon nigiri ",
              price: "$73.55"
            },
            {
              name:
                "Sushi Party Tray C (4-5ppl) : 1 Salmon OOSHI, 1 Canuck Roll, 2 Dynamite Roll, 2 California Roll, 1 Avocado Roll, 1 Spicy Tuna Roll, 2Pcs Salmon Nigiri, 2Pcs Tuna Nigiri, 2Pcs Ebi Nigiri",
              price: "$85.55"
            },
            {
              name:
                "Vegetable Maki Tray (2-3ppl) : 1 Veggie Roll, Veggie Tempura Roll, Yam Roll, lnari Roll, Avocado Roll, Cucumber Maki, Oshinko Maki, 2pcs Inari Nigiri",
              price: "$38.99"
            }
          ]
        },
        {
          category: "BOXES",
          items: [
            {
              name:
                "Box A - 1: Beef Teriyaki on Rice, 1 Califoria Roll, 2 Veggie ,1 Prawn Tempura, Salad, 1 Spring Roll",
              price: "$17.99"
            },
            {
              name:
                "BOX A - Chicken Teriyaki on Rice, 1 Califoria Roll, 2 Veggie ,1 Prawn Tempura, Salad, 1 Spring Roll",
              price: "$17.99"
            },
            {
              name:
                "BOX B: Tofu, Teriyaki on Rice, 1 Yam Roll, 3 Veggie Tempura, Salad, 1 Spring Roll",
              price: "$16.95"
            },
            {
              name:
                "BOX C: Salmon Teriyaki on Rice, 1 Califoria Roll, 2 Veggie,1 Prawn Tempura, Salad, 1 Spring ROLL",
              price: "$19.99"
            },
            {
              name:
                "SASHIMI BOX: 2PCS VEGETABLETEMPURA, 1 PC PRAWN TEMPURA, 1 DYNAMITE ROLL, 2 PCS TUNA  AND 3 PCS SALMON SASHIMI, SALAD, 1 PC SPRING ROLL",
              price: "$26.99"
            }
          ]
        }
      ]
    };
  },
  computed: {
    selectedTab() {
      return this.foodMenu[this.key].category;
      //return this.foodMenu;
    }
  },
  methods: {
    switchTab(key) {
      this.key = key;
      //set active tab
      this.$store.commit("setKey", this.key);
      console.log(this.key);
      console.log(this.$store.state.imageArrayKey);
    },
    activeClass(i) {
      if (this.key == i) {
        return "active";
      } else {
        return "";
      }
    }
  },
  /*
  mounted() {
    axios
      .get("../wp-json/wp/v2/sushimenus?_embeded=1&_links=1&per_page=100")
      .then(response => {
        this.foodMenu = HelperTools.SanitizeMenuResponse(response.data);
      });
  },*/

  components: { Tabs, Tab, TabPanels, TabPanel }
};
</script>

<style>
.tab-panels {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tab {
  padding: 0.25rem 0.75rem !important;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 36px;
  /* or 150% */

  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.tab:visited {
  border-bottom: 1px solid white;
}

.bc-tab-panel {
  /*default set to inline block with non-scroll, so the item were hidden*/
  display: block;
}

.active {
  background: #c7272b;
  border-radius: 6px;
}

@media only screen and (max-width: 639px) {
  .tab {
    font-size: 0.75rem;
    padding: 5px !important;
  }
}
</style>